import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "@/routes/AppRouter";
import { useEffect } from "react";
import { useAppStore } from "@/store/appStore";
import { ToastHost } from "@/components/ui";
import { startOperaPushNotifications } from "@/native/operaPushNotifications";

const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || undefined;

function resolveTheme(theme: "light" | "dark" | "system") {
  if (theme === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return theme;
}

export default function App() {
  const theme = useAppStore((s) => s.theme);
  const bootstrapAuth = useAppStore((s) => s.bootstrapAuth);
  const authReady = useAppStore((s) => s.authReady);
  const isAuthenticated = useAppStore((s) => s.isAuthenticated);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolveTheme(theme));
  }, [theme]);

  useEffect(() => {
    void bootstrapAuth();
  }, [bootstrapAuth]);

  // Push only after auth — permission denial must not break OPERA OS.
  useEffect(() => {
    if (!authReady || !isAuthenticated) return;
    void startOperaPushNotifications();
  }, [authReady, isAuthenticated]);

  return (
    <BrowserRouter basename={basename}>
      <AppRouter />
      <ToastHost />
    </BrowserRouter>
  );
}
